// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronLeft20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronLeft20: FC<ChevronLeft20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m11.381 16-4.914-6 4.914-6 1.238 1.007L8.534 10l4.085 4.993L11.381 16Z" />
        </svg>
    );
};

export default ChevronLeft20;
